import { useEffect, useState } from 'react'

export interface CountdownParts {
  days: number
  hours: number
  minutes: number
  seconds: number
  isDone: boolean
}

function getParts(target: number): CountdownParts {
  const diff = Math.max(0, target - Date.now())
  return {
    days: Math.floor(diff / 86_400_000),
    hours: Math.floor((diff / 3_600_000) % 24),
    minutes: Math.floor((diff / 60_000) % 60),
    seconds: Math.floor((diff / 1000) % 60),
    isDone: diff === 0,
  }
}

/** Ticks every second until the target time has passed. */
export function useCountdown(targetIso: string): CountdownParts {
  const target = new Date(targetIso).getTime()
  const [parts, setParts] = useState(() => getParts(target))

  useEffect(() => {
    if (parts.isDone) return
    const id = window.setInterval(() => setParts(getParts(target)), 1000)
    return () => window.clearInterval(id)
  }, [target, parts.isDone])

  return parts
}
